import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CadensSharedModule} from '../shared';

import {CalendarModule, ConfirmDialogModule, DataTableModule, DialogModule, FileUploadModule} from 'primeng/primeng';


import {
    adminState,
    AideComponent,
    AuditsComponent,
    AuditsService,
    JhiArchiveComponent,
    JhiArchiveService,
    JhiConfigurationComponent,
    JhiConfigurationService,
    JhiDocsComponent,
    JhiHealthCheckComponent,
    JhiHealthModalComponent,
    JhiHealthService,
    JhiMetricsMonitoringComponent,
    JhiMetricsMonitoringModalComponent,
    JhiMetricsService,
    LogsComponent,
    LogsService,
    TreeView,
    UserDeleteDialogComponent,
    UserDialogComponent,
    UserEchangeDeleteDialogComponent,
    UserEchangeDialogComponent,
    UserEchangeMgmtComponent,
    UserEchangeMgmtDeleteDialogComponent,
    UserEchangeMgmtDetailComponent,
    UserEchangeMgmtDialogComponent,
    UserMgmtComponent,
    UserMgmtDeleteDialogComponent,
    UserMgmtDetailComponent,
    UserMgmtDialogComponent,
    UserModalService,
    UserResolve,
    UserResolvePagingParams
} from './';
import {UserEchangeModalService} from './user-echange/user-echange-modal.service';
import {PrettyPrintPipe} from './archive/prettyPrint';


@NgModule({
    imports: [
        CadensSharedModule,
        DialogModule,
        DataTableModule,
        ConfirmDialogModule,
        FileUploadModule,
        RouterModule.forRoot(adminState, {useHash: true}),
        CalendarModule
    ],
    declarations: [
        AuditsComponent,
        UserMgmtComponent,
        UserDialogComponent,
        UserDeleteDialogComponent,
        UserMgmtDetailComponent,
        UserMgmtDialogComponent,
        UserMgmtDeleteDialogComponent,

        UserEchangeMgmtComponent,
        UserEchangeDialogComponent,
        UserEchangeDeleteDialogComponent,
        UserEchangeMgmtDetailComponent,
        UserEchangeMgmtDialogComponent,
        UserEchangeMgmtDeleteDialogComponent,
        AideComponent,
        LogsComponent,
        JhiConfigurationComponent,
        PrettyPrintPipe,
        JhiArchiveComponent,
        TreeView,
        JhiHealthCheckComponent,
        JhiHealthModalComponent,
        JhiDocsComponent,
        JhiMetricsMonitoringComponent,
        JhiMetricsMonitoringModalComponent
    ],
    entryComponents: [
        UserMgmtDialogComponent,
        UserMgmtDeleteDialogComponent,
        UserEchangeMgmtDialogComponent,
        UserEchangeMgmtDeleteDialogComponent,
        JhiHealthModalComponent,
        JhiMetricsMonitoringModalComponent,
    ],
    providers: [
        AuditsService,
        JhiConfigurationService,
        JhiArchiveService,
        JhiHealthService,
        JhiMetricsService,
        LogsService,
        UserResolvePagingParams,
        UserResolve,
        UserModalService,
        UserEchangeModalService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensAdminModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/admin.module.ts